exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".release-editor{width:640px;display:flex;flex-direction:row;margin-top:8px;margin-bottom:8px}.release-editor .num-picker{width:50%}.release-editor .select{width:50%}", ""]);

